
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rapyd",
      function () {
        return require("private-next-pages/rapyd/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rapyd"])
      });
    }
  